export default __webpack_public_path__ + "logo_ru.693c46a0.svg";